/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/booking/list/booking-list.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import7 from '../../../../../../public/upgrade/feature/booking/booking.service';
import * as import8 from 'ngx-cookie/src/cookie.service';
import * as import9 from '@angular/core/src/linker/view_type';
import * as import10 from '@angular/core/src/change_detection/constants';
import * as import11 from '@angular/core/src/linker/component_factory';
import * as import12 from '@angular/http/src/http';
import * as import13 from 'ngx-cookie/src/cookie-options-provider';
import * as import14 from '@angular/router/src/router';
import * as import15 from '@angular/router/src/router_state';
import * as import16 from '@ngx-translate/core/src/translate.service';
import * as import17 from '../../../../../../public/upgrade/core/mobile.service';
import * as import18 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import19 from '../../../../../../public/upgrade/core/session.service';
import * as import20 from '@ngx-translate/core/src/translate.pipe';
import * as import21 from '@angular/core/src/linker/view_container';
import * as import22 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import25 from '@angular/common/src/directives/ng_for';
import * as import26 from '../../../../../../public/upgrade/feature/booking/new-feature-tooltip.component';
import * as import27 from '../new-feature-tooltip.component.ngfactory';
import * as import28 from '../../../../../../public/upgrade/shared/checkbox-container/checkbox-container.component';
import * as import29 from '../../../shared/checkbox-container/checkbox-container.component.ngfactory';
import * as import30 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import31 from '../../../../../../public/upgrade/feature/booking/email-tooltip.component';
import * as import32 from '../email-tooltip.component.ngfactory';
import * as import33 from '@angular/common/src/directives/ng_if';
export class Wrapper_BookingListComponent {
  /*private*/ _eventHandler:Function;
  context:import0.BookingListComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any) {
    this._changed = false;
    this.context = new import0.BookingListComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_check(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.check = currValue;
      this._expr_0 = currValue;
    }
  }
  check_list(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.list = currValue;
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_BookingListComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_BookingListComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.BookingListComponent>;
  _GAService_0_3:import6.GAService;
  _BookingService_0_4:import7.BookingService;
  _CookieService_0_5:import8.CookieService;
  _BookingListComponent_0_6:Wrapper_BookingListComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_BookingListComponent_Host0,renderType_BookingListComponent_Host,import9.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'booking-list',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_BookingListComponent0(this.viewUtils,this,0,this._el_0);
    this._GAService_0_3 = new import6.GAService();
    this._BookingService_0_4 = new import7.BookingService(this.injectorGet(import12.Http,this.parentIndex));
    this._CookieService_0_5 = new import8.CookieService(this.injectorGet(import13.CookieOptionsProvider,this.parentIndex));
    this._BookingListComponent_0_6 = new Wrapper_BookingListComponent(this.injectorGet(import14.Router,this.parentIndex),this.injectorGet(import15.ActivatedRoute,this.parentIndex),this._GAService_0_3,this.injectorGet(import16.TranslateService,this.parentIndex),this.injectorGet(import17.MobileService,this.parentIndex),this._BookingService_0_4,this.injectorGet(import18.NotificationService,this.parentIndex),this.injectorGet(import19.SessionService,this.parentIndex),this._CookieService_0_5);
    this.compView_0.create(this._BookingListComponent_0_6.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import11.ComponentRef_<any>(0,this,this._el_0,this._BookingListComponent_0_6.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.GAService) && (0 === requestNodeIndex))) { return this._GAService_0_3; }
    if (((token === import7.BookingService) && (0 === requestNodeIndex))) { return this._BookingService_0_4; }
    if (((token === import8.CookieService) && (0 === requestNodeIndex))) { return this._CookieService_0_5; }
    if (((token === import0.BookingListComponent) && (0 === requestNodeIndex))) { return this._BookingListComponent_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._BookingListComponent_0_6.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const BookingListComponentNgFactory:import11.ComponentFactory<import0.BookingListComponent> = new import11.ComponentFactory<import0.BookingListComponent>('booking-list',View_BookingListComponent_Host0,import0.BookingListComponent);
const styles_BookingListComponent:any[] = ([] as any[]);
class View_BookingListComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  /*private*/ _expr_21:any;
  _pipe_translate_0:import20.TranslatePipe;
  /*private*/ _expr_23:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import21.ViewContainer) {
    super(View_BookingListComponent2,renderType_BookingListComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_21 = import1.UNINITIALIZED;
    this._expr_23 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','upgrade-container col -lg-4 -md-4 -sm-12 icon-container'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','icon-booking star-icon-booking'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','eva-3-icon-arrow-up -eva-3-icon-sm -eva-3-tc-blue-1 icon-add-list compose-icon-one'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','eva-3-icon-arrow-up -eva-3-icon-sm -eva-3-tc-blue-1 icon-add-list compose-icon-two'),(null as any));
    this._text_7 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','list-booking -eva-3-ml-sm'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                                ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_9,'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-1'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_9,'\n                                ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_9,'ul',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                                    ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'li',new import3.InlineArray2(2,'class',''),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._text_18 = this.renderer.createText(this._el_14,'\n                                ',(null as any));
    this._text_19 = this.renderer.createText(this._el_9,'\n                            ',(null as any));
    this._text_20 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_translate_0 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._text_20
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_21:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.CARD.upgradeA')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_21,currVal_21))) {
      this.renderer.setText(this._text_12,currVal_21);
      this._expr_21 = currVal_21;
    }
    const currVal_23:any = import3.inlineInterpolate(1,' ',((this.parentView.context.$implicit.upgradeCarDTO.upgradeCarBrand + ' ') + this.parentView.context.$implicit.upgradeCarDTO.upgradeCarModel),' ');
    if (import3.checkBinding(throwOnChange,this._expr_23,currVal_23)) {
      this.renderer.setText(this._text_17,currVal_23);
      this._expr_23 = currVal_23;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingListComponent4 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import20.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import21.ViewContainer) {
    super(View_BookingListComponent4,renderType_BookingListComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'li',new import3.InlineArray2(2,'class',''),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('additionalPrice.additional.' + this.context.$implicit))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingListComponent3 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _anchor_18:any;
  /*private*/ _vc_18:import21.ViewContainer;
  _TemplateRef_18_5:any;
  _NgFor_18_6:import22.Wrapper_NgFor;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  /*private*/ _expr_27:any;
  _pipe_translate_0:import20.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import21.ViewContainer) {
    super(View_BookingListComponent3,renderType_BookingListComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_27 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12 booking-additional-list -eva-3-pb-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 icon-container -eva-3-pl-sm'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','icon-booking star-icon-booking'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'i',new import3.InlineArray2(2,'class','eva-3-icon-star -eva-3-icon-sm -eva-3-tc-blue-1 icon-add-list'),(null as any));
    this._text_9 = this.renderer.createText(this._el_6,'\n                                    ',(null as any));
    this._text_10 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','list-booking -eva-3-ml-sm'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                                        ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_11,'p',new import3.InlineArray2(2,'class','-eva-3-bold -eva-3-tc-gray-1'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_11,'\n                                        ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_11,'ul',new import3.InlineArray2(2,'class','-eva-3-tc-gray-3'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n                                            ',(null as any));
    this._anchor_18 = this.renderer.createTemplateAnchor(this._el_16,(null as any));
    this._vc_18 = new import21.ViewContainer(18,16,this,this._anchor_18);
    this._TemplateRef_18_5 = new import23.TemplateRef_(this,18,this._anchor_18);
    this._NgFor_18_6 = new import22.Wrapper_NgFor(this._vc_18.vcRef,this._TemplateRef_18_5,this.parentView.parentView.injectorGet(import24.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.ref);
    this._text_19 = this.renderer.createText(this._el_16,'\n                                        ',(null as any));
    this._text_20 = this.renderer.createText(this._el_11,'\n                                    ',(null as any));
    this._text_21 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._text_22 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._text_23 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._pipe_translate_0 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._anchor_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (18 === requestNodeIndex))) { return this._TemplateRef_18_5; }
    if (((token === import25.NgFor) && (18 === requestNodeIndex))) { return this._NgFor_18_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_18_0_0:any = this.parentView.context.$implicit.additionals;
    this._NgFor_18_6.check_ngForOf(currVal_18_0_0,throwOnChange,false);
    this._NgFor_18_6.ngDoCheck(this,this._anchor_18,throwOnChange);
    this._vc_18.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_27:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.additionals')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_27,currVal_27))) {
      this.renderer.setText(this._text_14,currVal_27);
      this._expr_27 = currVal_27;
    }
  }
  destroyInternal():void {
    this._vc_18.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 18)) { return new View_BookingListComponent4(this.viewUtils,this,18,this._anchor_18,this._vc_18); }
    return (null as any);
  }
}
class View_BookingListComponent5 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import26.NewFeatureTooltipComponent>;
  _CookieService_2_3:import8.CookieService;
  _NewFeatureTooltipComponent_2_4:import27.Wrapper_NewFeatureTooltipComponent;
  __GAService_2_5:import6.GAService;
  __BookingService_2_6:import7.BookingService;
  _text_3:any;
  _pipe_translate_0:import20.TranslatePipe;
  _pipe_translate_1:import20.TranslatePipe;
  _pipe_translate_2:import20.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import21.ViewContainer) {
    super(View_BookingListComponent5,renderType_BookingListComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  get _GAService_2_5():import6.GAService {
    if ((this.__GAService_2_5 == null)) { (this.__GAService_2_5 = new import6.GAService()); }
    return this.__GAService_2_5;
  }
  get _BookingService_2_6():import7.BookingService {
    if ((this.__BookingService_2_6 == null)) { (this.__BookingService_2_6 = new import7.BookingService(this.parentView.parentView.injectorGet(import12.Http,this.parentView.parentIndex))); }
    return this.__BookingService_2_6;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'new-feature-tooltip',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import27.View_NewFeatureTooltipComponent0(this.viewUtils,this,2,this._el_2);
    this._CookieService_2_3 = new import8.CookieService(this.parentView.parentView.injectorGet(import13.CookieOptionsProvider,this.parentView.parentIndex));
    this._NewFeatureTooltipComponent_2_4 = new import27.Wrapper_NewFeatureTooltipComponent(this.parentView.parentView.injectorGet(import17.MobileService,this.parentView.parentIndex),this._CookieService_2_3);
    this.compView_2.create(this._NewFeatureTooltipComponent_2_4.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_translate_0 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_2 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import8.CookieService) && (2 === requestNodeIndex))) { return this._CookieService_2_3; }
    if (((token === import26.NewFeatureTooltipComponent) && (2 === requestNodeIndex))) { return this._NewFeatureTooltipComponent_2_4.context; }
    if (((token === import6.GAService) && (2 === requestNodeIndex))) { return this._GAService_2_5; }
    if (((token === import7.BookingService) && (2 === requestNodeIndex))) { return this._BookingService_2_6; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2_0_0:any = valUnwrapper.unwrap(this._pipe_translate_0.transform('new.feature.tooltipTitle'));
    this._NewFeatureTooltipComponent_2_4.check_title(currVal_2_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    valUnwrapper.reset();
    const currVal_2_0_1:any = valUnwrapper.unwrap(this._pipe_translate_1.transform('new.feature.tooltipBody'));
    this._NewFeatureTooltipComponent_2_4.check_body(currVal_2_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    valUnwrapper.reset();
    const currVal_2_0_2:any = valUnwrapper.unwrap(this._pipe_translate_2.transform('new.feature.tooltipButton'));
    this._NewFeatureTooltipComponent_2_4.check_button(currVal_2_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    this._NewFeatureTooltipComponent_2_4.ngDoCheck(this,this._el_2,throwOnChange);
    if (!throwOnChange) { this._NewFeatureTooltipComponent_2_4.context.ngAfterContentChecked(); }
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingListComponent6 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import20.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import21.ViewContainer) {
    super(View_BookingListComponent6,renderType_BookingListComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-pb-xsm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('booking.includedAdditionals')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingListComponent7 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import20.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import21.ViewContainer) {
    super(View_BookingListComponent7,renderType_BookingListComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','-eva-3-pb-xsm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('booking.nonIncludedAdditionals')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingListComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  compView_10:import2.AppView<import28.CheckboxContainerComponent>;
  _CheckboxContainerComponent_10_3:import29.Wrapper_CheckboxContainerComponent;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _text_28:any;
  _el_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _el_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _el_51:any;
  _text_52:any;
  _text_53:any;
  _el_54:any;
  _text_55:any;
  _el_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _text_60:any;
  _el_61:any;
  _text_62:any;
  _text_63:any;
  _text_64:any;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  _el_68:any;
  _text_69:any;
  _el_70:any;
  _text_71:any;
  _el_72:any;
  _text_73:any;
  _el_74:any;
  _text_75:any;
  _text_76:any;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _el_82:any;
  _text_83:any;
  _el_84:any;
  _text_85:any;
  _el_86:any;
  _text_87:any;
  _text_88:any;
  _text_89:any;
  _text_90:any;
  _text_91:any;
  _el_92:any;
  _text_93:any;
  _el_94:any;
  _text_95:any;
  _el_96:any;
  _text_97:any;
  _el_98:any;
  _text_99:any;
  _text_100:any;
  _el_101:any;
  _text_102:any;
  _el_103:any;
  _text_104:any;
  _el_105:any;
  _text_106:any;
  _text_107:any;
  _el_108:any;
  _text_109:any;
  _text_110:any;
  _text_111:any;
  _text_112:any;
  _text_113:any;
  _text_114:any;
  _el_115:any;
  _text_116:any;
  _el_117:any;
  _text_118:any;
  _el_119:any;
  _text_120:any;
  _el_121:any;
  _text_122:any;
  _text_123:any;
  _text_124:any;
  _text_125:any;
  _text_126:any;
  _text_127:any;
  _anchor_128:any;
  /*private*/ _vc_128:import21.ViewContainer;
  _TemplateRef_128_5:any;
  _NgIf_128_6:import30.Wrapper_NgIf;
  _text_129:any;
  _anchor_130:any;
  /*private*/ _vc_130:import21.ViewContainer;
  _TemplateRef_130_5:any;
  _NgIf_130_6:import30.Wrapper_NgIf;
  _text_131:any;
  _text_132:any;
  _text_133:any;
  _el_134:any;
  _text_135:any;
  _el_136:any;
  _text_137:any;
  _el_138:any;
  _text_139:any;
  _anchor_140:any;
  /*private*/ _vc_140:import21.ViewContainer;
  _TemplateRef_140_5:any;
  _NgIf_140_6:import30.Wrapper_NgIf;
  _text_141:any;
  _el_142:any;
  compView_142:import2.AppView<import31.EmailTooltipComponent>;
  _GAService_142_3:import6.GAService;
  _MobileService_142_4:import17.MobileService;
  _BookingService_142_5:import7.BookingService;
  _EmailTooltipComponent_142_6:import32.Wrapper_EmailTooltipComponent;
  _text_143:any;
  _text_144:any;
  _text_145:any;
  _el_146:any;
  _text_147:any;
  _el_148:any;
  _text_149:any;
  _el_150:any;
  _text_151:any;
  _text_152:any;
  _el_153:any;
  _text_154:any;
  _text_155:any;
  _text_156:any;
  _text_157:any;
  _el_158:any;
  _text_159:any;
  _el_160:any;
  _text_161:any;
  _el_162:any;
  _text_163:any;
  _el_164:any;
  _text_165:any;
  _text_166:any;
  _el_167:any;
  _text_168:any;
  _el_169:any;
  _text_170:any;
  _text_171:any;
  _el_172:any;
  _text_173:any;
  _text_174:any;
  _text_175:any;
  _anchor_176:any;
  /*private*/ _vc_176:import21.ViewContainer;
  _TemplateRef_176_5:any;
  _NgIf_176_6:import30.Wrapper_NgIf;
  _text_177:any;
  _anchor_178:any;
  /*private*/ _vc_178:import21.ViewContainer;
  _TemplateRef_178_5:any;
  _NgIf_178_6:import30.Wrapper_NgIf;
  _text_179:any;
  _text_180:any;
  _text_181:any;
  _text_182:any;
  _text_183:any;
  _text_184:any;
  _text_185:any;
  _text_186:any;
  /*private*/ _expr_209:any;
  /*private*/ _expr_210:any;
  /*private*/ _expr_211:any;
  _pipe_translate_0:import20.TranslatePipe;
  _pipe_translate_1:import20.TranslatePipe;
  /*private*/ _expr_214:any;
  /*private*/ _expr_215:any;
  /*private*/ _expr_216:any;
  _pipe_translate_2:import20.TranslatePipe;
  /*private*/ _expr_218:any;
  /*private*/ _expr_219:any;
  /*private*/ _expr_220:any;
  /*private*/ _expr_221:any;
  _pipe_translate_3:import20.TranslatePipe;
  /*private*/ _expr_223:any;
  _pipe_translate_4:import20.TranslatePipe;
  /*private*/ _expr_225:any;
  /*private*/ _expr_226:any;
  _pipe_translate_5:import20.TranslatePipe;
  _pipe_translate_6:import20.TranslatePipe;
  _pipe_translate_7:import20.TranslatePipe;
  /*private*/ _expr_230:any;
  _pipe_translate_8:import20.TranslatePipe;
  /*private*/ _expr_232:any;
  _pipe_translate_9:import20.TranslatePipe;
  /*private*/ _expr_234:any;
  /*private*/ _expr_235:any;
  _pipe_translate_10:import20.TranslatePipe;
  /*private*/ _expr_237:any;
  _pipe_translate_11:import20.TranslatePipe;
  /*private*/ _expr_239:any;
  _pipe_translate_12:import20.TranslatePipe;
  /*private*/ _expr_241:any;
  /*private*/ _expr_242:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import21.ViewContainer) {
    super(View_BookingListComponent1,renderType_BookingListComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_209 = import1.UNINITIALIZED;
    this._expr_210 = import1.UNINITIALIZED;
    this._expr_211 = import1.UNINITIALIZED;
    this._expr_214 = import1.UNINITIALIZED;
    this._expr_215 = import1.UNINITIALIZED;
    this._expr_216 = import1.UNINITIALIZED;
    this._expr_218 = import1.UNINITIALIZED;
    this._expr_219 = import1.UNINITIALIZED;
    this._expr_220 = import1.UNINITIALIZED;
    this._expr_221 = import1.UNINITIALIZED;
    this._expr_223 = import1.UNINITIALIZED;
    this._expr_225 = import1.UNINITIALIZED;
    this._expr_226 = import1.UNINITIALIZED;
    this._expr_230 = import1.UNINITIALIZED;
    this._expr_232 = import1.UNINITIALIZED;
    this._expr_234 = import1.UNINITIALIZED;
    this._expr_235 = import1.UNINITIALIZED;
    this._expr_237 = import1.UNINITIALIZED;
    this._expr_239 = import1.UNINITIALIZED;
    this._expr_241 = import1.UNINITIALIZED;
    this._expr_242 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-eva-3-ml-sm'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'dsp-booking-ticket',new import3.InlineArray2(2,'id','booking-ticket'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'dsp-booking-ticket-header',new import3.InlineArray2(2,'slot','header'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'checkbox-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_10 = new import29.View_CheckboxContainerComponent0(this.viewUtils,this,10,this._el_10);
    this._CheckboxContainerComponent_10_3 = new import29.Wrapper_CheckboxContainerComponent();
    this.compView_10.create(this._CheckboxContainerComponent_10_3.context);
    this._text_11 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_12 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'slot','body'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                    ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                        ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 icon-container'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                            ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'div',new import3.InlineArray2(2,'class','icon-booking icon-top'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n                                ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_19,'i',new import3.InlineArray2(2,'class','eva-3-icon-cars -eva-3-icon-md -eva-3-tc-blue-1'),(null as any));
    this._text_22 = this.renderer.createText(this._el_19,'\n                            ',(null as any));
    this._text_23 = this.renderer.createText(this._el_17,'\n                            ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_17,'div',new import3.InlineArray2(2,'class','text-booking -eva-3-pb-sm'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n                                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_24,'p',new import3.InlineArray2(2,'class','eva-3-h6 -eva-3-bold -eva-3-tc-gray-1'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'',(null as any));
    this._text_28 = this.renderer.createText(this._el_24,'\n                                ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_24,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_30 = this.renderer.createText(this._el_29,'\n                                    ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_29,'span',new import3.InlineArray4(4,'class','-eva-3-tc-gray-3','qadata','carBrand'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'',(null as any));
    this._text_33 = this.renderer.createText(this._el_29,'\n                                    ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_29,'span',new import3.InlineArray4(4,'class','-eva-3-italic -eva-3-tc-gray-2','qadata','carModel'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_29,'\n                                ',(null as any));
    this._text_37 = this.renderer.createText(this._el_24,'\n                            ',(null as any));
    this._text_38 = this.renderer.createText(this._el_17,'\n                        ',(null as any));
    this._text_39 = this.renderer.createText(this._el_15,'\n                    ',(null as any));
    this._text_40 = this.renderer.createText(this._el_13,'\n                    ',(null as any));
    this._el_41 = import3.createRenderElement(this.renderer,this._el_13,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'\n                        ',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_41,'div',new import3.InlineArray2(2,'class','col -lg-8 -md-8 -sm-12'),(null as any));
    this._text_44 = this.renderer.createText(this._el_43,'\n                            ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_43,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n                                ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_45,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                                    ',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_47,'div',new import3.InlineArray2(2,'class','icon-booking'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'\n                                        ',(null as any));
    this._el_51 = import3.createRenderElement(this.renderer,this._el_49,'div',new import3.InlineArray2(2,'class','circle'),(null as any));
    this._text_52 = this.renderer.createText(this._el_49,'\n                                    ',(null as any));
    this._text_53 = this.renderer.createText(this._el_47,'\n                                    ',(null as any));
    this._el_54 = import3.createRenderElement(this.renderer,this._el_47,'div',new import3.InlineArray2(2,'class','text-booking'),(null as any));
    this._text_55 = this.renderer.createText(this._el_54,'\n                                        ',(null as any));
    this._el_56 = import3.createRenderElement(this.renderer,this._el_54,'p',new import3.InlineArray2(2,'class','eva-3-p -eva-3-tc-gray-3'),(null as any));
    this._text_57 = this.renderer.createText(this._el_56,'\n                                            ',(null as any));
    this._el_58 = import3.createRenderElement(this.renderer,this._el_56,'span',new import3.InlineArray4(4,'class','-eva-3-h6 -eva-3-bold','qadata','pickupDate'),(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'',(null as any));
    this._text_60 = this.renderer.createText(this._el_56,'\n                                            ',(null as any));
    this._el_61 = import3.createRenderElement(this.renderer,this._el_56,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_62 = this.renderer.createText(this._el_61,'',(null as any));
    this._text_63 = this.renderer.createText(this._el_56,'\n                                        ',(null as any));
    this._text_64 = this.renderer.createText(this._el_54,'\n                                    ',(null as any));
    this._text_65 = this.renderer.createText(this._el_47,'\n                                ',(null as any));
    this._text_66 = this.renderer.createText(this._el_45,'\n                            ',(null as any));
    this._text_67 = this.renderer.createText(this._el_43,'\n                            ',(null as any));
    this._el_68 = import3.createRenderElement(this.renderer,this._el_43,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_69 = this.renderer.createText(this._el_68,'\n                                ',(null as any));
    this._el_70 = import3.createRenderElement(this.renderer,this._el_68,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_71 = this.renderer.createText(this._el_70,'\n                                    ',(null as any));
    this._el_72 = import3.createRenderElement(this.renderer,this._el_70,'div',new import3.InlineArray2(2,'class','text-travel-booking eva-3-p'),(null as any));
    this._text_73 = this.renderer.createText(this._el_72,'\n                                        ',(null as any));
    this._el_74 = import3.createRenderElement(this.renderer,this._el_72,'p',new import3.InlineArray4(4,'class','-eva-3-tc-gray-3','qadata','pickupCity'),(null as any));
    this._text_75 = this.renderer.createText(this._el_74,'',(null as any));
    this._text_76 = this.renderer.createText(this._el_72,'\n                                    ',(null as any));
    this._text_77 = this.renderer.createText(this._el_70,'\n                                ',(null as any));
    this._text_78 = this.renderer.createText(this._el_68,'\n                            ',(null as any));
    this._text_79 = this.renderer.createText(this._el_43,'\n                            ',(null as any));
    this._el_80 = import3.createRenderElement(this.renderer,this._el_43,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'\n                                ',(null as any));
    this._el_82 = import3.createRenderElement(this.renderer,this._el_80,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_83 = this.renderer.createText(this._el_82,'\n                                    ',(null as any));
    this._el_84 = import3.createRenderElement(this.renderer,this._el_82,'div',new import3.InlineArray2(2,'class','text-travel-booking -eva-3-pb-sm'),(null as any));
    this._text_85 = this.renderer.createText(this._el_84,'\n                                        ',(null as any));
    this._el_86 = import3.createRenderElement(this.renderer,this._el_84,'p',new import3.InlineArray2(2,'class','-eva-3-tc-blue-1 -eva-3-pt-xsm'),(null as any));
    this._text_87 = this.renderer.createText(this._el_86,'',(null as any));
    this._text_88 = this.renderer.createText(this._el_84,'\n                                    ',(null as any));
    this._text_89 = this.renderer.createText(this._el_82,'\n                                ',(null as any));
    this._text_90 = this.renderer.createText(this._el_80,'\n                            ',(null as any));
    this._text_91 = this.renderer.createText(this._el_43,'\n                            ',(null as any));
    this._el_92 = import3.createRenderElement(this.renderer,this._el_43,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_93 = this.renderer.createText(this._el_92,'\n                                ',(null as any));
    this._el_94 = import3.createRenderElement(this.renderer,this._el_92,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_95 = this.renderer.createText(this._el_94,'\n                                    ',(null as any));
    this._el_96 = import3.createRenderElement(this.renderer,this._el_94,'div',new import3.InlineArray2(2,'class','icon-booking -eva-3-pt-xsm'),(null as any));
    this._text_97 = this.renderer.createText(this._el_96,'\n                                        ',(null as any));
    this._el_98 = import3.createRenderElement(this.renderer,this._el_96,'div',new import3.InlineArray2(2,'class','circle bottom'),(null as any));
    this._text_99 = this.renderer.createText(this._el_96,'\n                                    ',(null as any));
    this._text_100 = this.renderer.createText(this._el_94,'\n                                    ',(null as any));
    this._el_101 = import3.createRenderElement(this.renderer,this._el_94,'div',new import3.InlineArray2(2,'class','text-booking'),(null as any));
    this._text_102 = this.renderer.createText(this._el_101,'\n                                        ',(null as any));
    this._el_103 = import3.createRenderElement(this.renderer,this._el_101,'p',new import3.InlineArray2(2,'class','eva-3-p -eva-3-tc-gray-3'),(null as any));
    this._text_104 = this.renderer.createText(this._el_103,'\n                                            ',(null as any));
    this._el_105 = import3.createRenderElement(this.renderer,this._el_103,'span',new import3.InlineArray4(4,'class','-eva-3-h6 -eva-3-bold','qadata','dropoffDate'),(null as any));
    this._text_106 = this.renderer.createText(this._el_105,'',(null as any));
    this._text_107 = this.renderer.createText(this._el_103,'\n                                            ',(null as any));
    this._el_108 = import3.createRenderElement(this.renderer,this._el_103,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_109 = this.renderer.createText(this._el_108,'',(null as any));
    this._text_110 = this.renderer.createText(this._el_103,'\n                                        ',(null as any));
    this._text_111 = this.renderer.createText(this._el_101,'\n                                    ',(null as any));
    this._text_112 = this.renderer.createText(this._el_94,'\n                                ',(null as any));
    this._text_113 = this.renderer.createText(this._el_92,'\n                            ',(null as any));
    this._text_114 = this.renderer.createText(this._el_43,'\n                            ',(null as any));
    this._el_115 = import3.createRenderElement(this.renderer,this._el_43,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_116 = this.renderer.createText(this._el_115,'\n                                ',(null as any));
    this._el_117 = import3.createRenderElement(this.renderer,this._el_115,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_118 = this.renderer.createText(this._el_117,'\n                                    ',(null as any));
    this._el_119 = import3.createRenderElement(this.renderer,this._el_117,'div',new import3.InlineArray2(2,'class','-eva-3-pb-sm -eva-3-pl-xlg'),(null as any));
    this._text_120 = this.renderer.createText(this._el_119,'\n                                        ',(null as any));
    this._el_121 = import3.createRenderElement(this.renderer,this._el_119,'p',new import3.InlineArray4(4,'class','-eva-3-tc-gray-3','qadata','dropoffCity'),(null as any));
    this._text_122 = this.renderer.createText(this._el_121,'',(null as any));
    this._text_123 = this.renderer.createText(this._el_119,'\n                                    ',(null as any));
    this._text_124 = this.renderer.createText(this._el_117,'\n                                ',(null as any));
    this._text_125 = this.renderer.createText(this._el_115,'\n                            ',(null as any));
    this._text_126 = this.renderer.createText(this._el_43,'\n                        ',(null as any));
    this._text_127 = this.renderer.createText(this._el_41,'\n                        ',(null as any));
    this._anchor_128 = this.renderer.createTemplateAnchor(this._el_41,(null as any));
    this._vc_128 = new import21.ViewContainer(128,41,this,this._anchor_128);
    this._TemplateRef_128_5 = new import23.TemplateRef_(this,128,this._anchor_128);
    this._NgIf_128_6 = new import30.Wrapper_NgIf(this._vc_128.vcRef,this._TemplateRef_128_5);
    this._text_129 = this.renderer.createText(this._el_41,'\n                        ',(null as any));
    this._anchor_130 = this.renderer.createTemplateAnchor(this._el_41,(null as any));
    this._vc_130 = new import21.ViewContainer(130,41,this,this._anchor_130);
    this._TemplateRef_130_5 = new import23.TemplateRef_(this,130,this._anchor_130);
    this._NgIf_130_6 = new import30.Wrapper_NgIf(this._vc_130.vcRef,this._TemplateRef_130_5);
    this._text_131 = this.renderer.createText(this._el_41,'\n                    ',(null as any));
    this._text_132 = this.renderer.createText(this._el_13,'\n                ',(null as any));
    this._text_133 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_134 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray4(4,'class','footer-ticket','slot','footer'),(null as any));
    this._text_135 = this.renderer.createText(this._el_134,'\n                    ',(null as any));
    this._el_136 = import3.createRenderElement(this.renderer,this._el_134,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_137 = this.renderer.createText(this._el_136,'\n                        ',(null as any));
    this._el_138 = import3.createRenderElement(this.renderer,this._el_136,'div',new import3.InlineArray2(2,'class','booking-info col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_139 = this.renderer.createText(this._el_138,'\n                            ',(null as any));
    this._anchor_140 = this.renderer.createTemplateAnchor(this._el_138,(null as any));
    this._vc_140 = new import21.ViewContainer(140,138,this,this._anchor_140);
    this._TemplateRef_140_5 = new import23.TemplateRef_(this,140,this._anchor_140);
    this._NgIf_140_6 = new import30.Wrapper_NgIf(this._vc_140.vcRef,this._TemplateRef_140_5);
    this._text_141 = this.renderer.createText(this._el_138,'\n                            ',(null as any));
    this._el_142 = import3.createRenderElement(this.renderer,this._el_138,'email-tooltip',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_142 = new import32.View_EmailTooltipComponent0(this.viewUtils,this,142,this._el_142);
    this._GAService_142_3 = new import6.GAService();
    this._MobileService_142_4 = new import17.MobileService();
    this._BookingService_142_5 = new import7.BookingService(this.parentView.injectorGet(import12.Http,this.parentIndex));
    this._EmailTooltipComponent_142_6 = new import32.Wrapper_EmailTooltipComponent(this._GAService_142_3,this._MobileService_142_4,this._BookingService_142_5,this.parentView.injectorGet(import18.NotificationService,this.parentIndex),this.parentView.injectorGet(import19.SessionService,this.parentIndex));
    this.compView_142.create(this._EmailTooltipComponent_142_6.context);
    this._text_143 = this.renderer.createText(this._el_138,'\n                        ',(null as any));
    this._text_144 = this.renderer.createText(this._el_136,'\n                    ',(null as any));
    this._text_145 = this.renderer.createText(this._el_134,'\n                    ',(null as any));
    this._el_146 = import3.createRenderElement(this.renderer,this._el_134,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_147 = this.renderer.createText(this._el_146,'\n                        ',(null as any));
    this._el_148 = import3.createRenderElement(this.renderer,this._el_146,'div',new import3.InlineArray2(2,'class','col -lg-9 -md-9 -sm-9 payment-detail'),(null as any));
    this._text_149 = this.renderer.createText(this._el_148,'\n                            ',(null as any));
    this._el_150 = import3.createRenderElement(this.renderer,this._el_148,'p',new import3.InlineArray4(4,'class','payment-detail-text eva-3-p -eva-3-bold inline -lg-12 -md-12 -sm-12','qadata','paymentMethod'),(null as any));
    this._text_151 = this.renderer.createText(this._el_150,'',(null as any));
    this._text_152 = this.renderer.createText(this._el_148,'\n                            ',(null as any));
    this._el_153 = import3.createRenderElement(this.renderer,this._el_148,'p',new import3.InlineArray2(2,'class','payment-detail-text -lg-12 -md-12 -sm-10'),(null as any));
    this._text_154 = this.renderer.createText(this._el_153,'',(null as any));
    this._text_155 = this.renderer.createText(this._el_148,'\n                        ',(null as any));
    this._text_156 = this.renderer.createText(this._el_146,'\n                    ',(null as any));
    this._text_157 = this.renderer.createText(this._el_134,'\n                    ',(null as any));
    this._el_158 = import3.createRenderElement(this.renderer,this._el_134,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_159 = this.renderer.createText(this._el_158,'\n                        ',(null as any));
    this._el_160 = import3.createRenderElement(this.renderer,this._el_158,'div',new import3.InlineArray2(2,'class','booking-info col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_161 = this.renderer.createText(this._el_160,'\n                            ',(null as any));
    this._el_162 = import3.createRenderElement(this.renderer,this._el_160,'div',new import3.InlineArray2(2,'class','price-booking'),(null as any));
    this._text_163 = this.renderer.createText(this._el_162,'\n                                ',(null as any));
    this._el_164 = import3.createRenderElement(this.renderer,this._el_162,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-1 -lg-6 -md-6 -sm-6 detail-line-text'),(null as any));
    this._text_165 = this.renderer.createText(this._el_164,'',(null as any));
    this._text_166 = this.renderer.createText(this._el_162,'\n                                ',(null as any));
    this._el_167 = import3.createRenderElement(this.renderer,this._el_162,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-1 -lg-6 -md-6 -sm-6'),(null as any));
    this._text_168 = this.renderer.createText(this._el_167,'\n                                    ',(null as any));
    this._el_169 = import3.createRenderElement(this.renderer,this._el_167,'span',new import3.InlineArray4(4,'class','-eva-3-icon-sm -eva-3-fr -eva-3-mr-sm','qadata','totalPrice'),(null as any));
    this._text_170 = this.renderer.createText(this._el_169,'',(null as any));
    this._text_171 = this.renderer.createText(this._el_167,'\n                                    ',(null as any));
    this._el_172 = import3.createRenderElement(this.renderer,this._el_167,'span',new import3.InlineArray2(2,'class','-eva-3-fr -eva-3-mr-xsm detail-line-text'),(null as any));
    this._text_173 = this.renderer.createText(this._el_172,'',(null as any));
    this._text_174 = this.renderer.createText(this._el_167,'\n                                ',(null as any));
    this._text_175 = this.renderer.createText(this._el_162,'\n                                ',(null as any));
    this._anchor_176 = this.renderer.createTemplateAnchor(this._el_162,(null as any));
    this._vc_176 = new import21.ViewContainer(176,162,this,this._anchor_176);
    this._TemplateRef_176_5 = new import23.TemplateRef_(this,176,this._anchor_176);
    this._NgIf_176_6 = new import30.Wrapper_NgIf(this._vc_176.vcRef,this._TemplateRef_176_5);
    this._text_177 = this.renderer.createText(this._el_162,'\n                                ',(null as any));
    this._anchor_178 = this.renderer.createTemplateAnchor(this._el_162,(null as any));
    this._vc_178 = new import21.ViewContainer(178,162,this,this._anchor_178);
    this._TemplateRef_178_5 = new import23.TemplateRef_(this,178,this._anchor_178);
    this._NgIf_178_6 = new import30.Wrapper_NgIf(this._vc_178.vcRef,this._TemplateRef_178_5);
    this._text_179 = this.renderer.createText(this._el_162,'\n                            ',(null as any));
    this._text_180 = this.renderer.createText(this._el_160,'\n                        ',(null as any));
    this._text_181 = this.renderer.createText(this._el_158,'\n                    ',(null as any));
    this._text_182 = this.renderer.createText(this._el_134,'\n                ',(null as any));
    this._text_183 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_184 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_185 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_186 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_6,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_6));
    this._pipe_translate_0 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_10,new import3.InlineArray4(4,'modelChange',(null as any),'click',(null as any)),this.eventHandler(this.handleEvent_10));
    this._CheckboxContainerComponent_10_3.subscribe(this,this.eventHandler(this.handleEvent_10),false,true);
    this._pipe_translate_2 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_3 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_4 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_5 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_6 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_7 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_8 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_9 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_10 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_11 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_12 = new import20.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._el_51,
      this._text_52,
      this._text_53,
      this._el_54,
      this._text_55,
      this._el_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._text_60,
      this._el_61,
      this._text_62,
      this._text_63,
      this._text_64,
      this._text_65,
      this._text_66,
      this._text_67,
      this._el_68,
      this._text_69,
      this._el_70,
      this._text_71,
      this._el_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._text_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._el_82,
      this._text_83,
      this._el_84,
      this._text_85,
      this._el_86,
      this._text_87,
      this._text_88,
      this._text_89,
      this._text_90,
      this._text_91,
      this._el_92,
      this._text_93,
      this._el_94,
      this._text_95,
      this._el_96,
      this._text_97,
      this._el_98,
      this._text_99,
      this._text_100,
      this._el_101,
      this._text_102,
      this._el_103,
      this._text_104,
      this._el_105,
      this._text_106,
      this._text_107,
      this._el_108,
      this._text_109,
      this._text_110,
      this._text_111,
      this._text_112,
      this._text_113,
      this._text_114,
      this._el_115,
      this._text_116,
      this._el_117,
      this._text_118,
      this._el_119,
      this._text_120,
      this._el_121,
      this._text_122,
      this._text_123,
      this._text_124,
      this._text_125,
      this._text_126,
      this._text_127,
      this._anchor_128,
      this._text_129,
      this._anchor_130,
      this._text_131,
      this._text_132,
      this._text_133,
      this._el_134,
      this._text_135,
      this._el_136,
      this._text_137,
      this._el_138,
      this._text_139,
      this._anchor_140,
      this._text_141,
      this._el_142,
      this._text_143,
      this._text_144,
      this._text_145,
      this._el_146,
      this._text_147,
      this._el_148,
      this._text_149,
      this._el_150,
      this._text_151,
      this._text_152,
      this._el_153,
      this._text_154,
      this._text_155,
      this._text_156,
      this._text_157,
      this._el_158,
      this._text_159,
      this._el_160,
      this._text_161,
      this._el_162,
      this._text_163,
      this._el_164,
      this._text_165,
      this._text_166,
      this._el_167,
      this._text_168,
      this._el_169,
      this._text_170,
      this._text_171,
      this._el_172,
      this._text_173,
      this._text_174,
      this._text_175,
      this._anchor_176,
      this._text_177,
      this._anchor_178,
      this._text_179,
      this._text_180,
      this._text_181,
      this._text_182,
      this._text_183,
      this._text_184,
      this._text_185,
      this._text_186
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.CheckboxContainerComponent) && (10 === requestNodeIndex))) { return this._CheckboxContainerComponent_10_3.context; }
    if (((token === import23.TemplateRef) && (128 === requestNodeIndex))) { return this._TemplateRef_128_5; }
    if (((token === import33.NgIf) && (128 === requestNodeIndex))) { return this._NgIf_128_6.context; }
    if (((token === import23.TemplateRef) && (130 === requestNodeIndex))) { return this._TemplateRef_130_5; }
    if (((token === import33.NgIf) && (130 === requestNodeIndex))) { return this._NgIf_130_6.context; }
    if (((token === import23.TemplateRef) && (140 === requestNodeIndex))) { return this._TemplateRef_140_5; }
    if (((token === import33.NgIf) && (140 === requestNodeIndex))) { return this._NgIf_140_6.context; }
    if (((token === import6.GAService) && (142 === requestNodeIndex))) { return this._GAService_142_3; }
    if (((token === import17.MobileService) && (142 === requestNodeIndex))) { return this._MobileService_142_4; }
    if (((token === import7.BookingService) && (142 === requestNodeIndex))) { return this._BookingService_142_5; }
    if (((token === import31.EmailTooltipComponent) && (142 === requestNodeIndex))) { return this._EmailTooltipComponent_142_6.context; }
    if (((token === import23.TemplateRef) && (176 === requestNodeIndex))) { return this._TemplateRef_176_5; }
    if (((token === import33.NgIf) && (176 === requestNodeIndex))) { return this._NgIf_176_6.context; }
    if (((token === import23.TemplateRef) && (178 === requestNodeIndex))) { return this._TemplateRef_178_5; }
    if (((token === import33.NgIf) && (178 === requestNodeIndex))) { return this._NgIf_178_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_10_0_0:any = 'markAsRead';
    this._CheckboxContainerComponent_10_3.check_name(currVal_10_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_10_0_1:any = valUnwrapper.unwrap(this._pipe_translate_2.transform('bookingList.CARD.markAsRead.label'));
    this._CheckboxContainerComponent_10_3.check_label(currVal_10_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_10_0_2:any = 'sm';
    this._CheckboxContainerComponent_10_3.check_size(currVal_10_0_2,throwOnChange,false);
    const currVal_10_0_3:boolean = !this.parentView.context.check;
    this._CheckboxContainerComponent_10_3.check_disabled(currVal_10_0_3,throwOnChange,false);
    const currVal_10_0_4:any = this.context.$implicit.readMark;
    this._CheckboxContainerComponent_10_3.check_model(currVal_10_0_4,throwOnChange,false);
    this._CheckboxContainerComponent_10_3.ngDoCheck(this,this._el_10,throwOnChange);
    const currVal_128_0_0:any = this.context.$implicit.upgradeCarDTO;
    this._NgIf_128_6.check_ngIf(currVal_128_0_0,throwOnChange,false);
    this._NgIf_128_6.ngDoCheck(this,this._anchor_128,throwOnChange);
    const currVal_130_0_0:any = (this.context.$implicit.additionals.length > 0);
    this._NgIf_130_6.check_ngIf(currVal_130_0_0,throwOnChange,false);
    this._NgIf_130_6.ngDoCheck(this,this._anchor_130,throwOnChange);
    const currVal_140_0_0:any = (this.context.index == 0);
    this._NgIf_140_6.check_ngIf(currVal_140_0_0,throwOnChange,false);
    this._NgIf_140_6.ngDoCheck(this,this._anchor_140,throwOnChange);
    const currVal_142_0_0:any = this.context.$implicit.oid;
    this._EmailTooltipComponent_142_6.check_bookingOid(currVal_142_0_0,throwOnChange,false);
    const currVal_142_0_1:any = this.parentView.context.companyOid;
    this._EmailTooltipComponent_142_6.check_companyOid(currVal_142_0_1,throwOnChange,false);
    const currVal_142_0_2:any = 'Contactar_PAX_Listado';
    this._EmailTooltipComponent_142_6.check_gaValue(currVal_142_0_2,throwOnChange,false);
    this._EmailTooltipComponent_142_6.ngDoCheck(this,this._el_142,throwOnChange);
    const currVal_176_0_0:any = (this.context.$implicit.additionals.length > 0);
    this._NgIf_176_6.check_ngIf(currVal_176_0_0,throwOnChange,false);
    this._NgIf_176_6.ngDoCheck(this,this._anchor_176,throwOnChange);
    const currVal_178_0_0:any = (this.context.$implicit.additionals.length == 0);
    this._NgIf_178_6.check_ngIf(currVal_178_0_0,throwOnChange,false);
    this._NgIf_178_6.ngDoCheck(this,this._anchor_178,throwOnChange);
    this._vc_128.detectChangesInNestedViews(throwOnChange);
    this._vc_130.detectChangesInNestedViews(throwOnChange);
    this._vc_140.detectChangesInNestedViews(throwOnChange);
    this._vc_176.detectChangesInNestedViews(throwOnChange);
    this._vc_178.detectChangesInNestedViews(throwOnChange);
    if (!throwOnChange) { this._EmailTooltipComponent_142_6.context.ngAfterContentChecked(); }
    const currVal_209:any = import3.inlineInterpolate(1,'',this.context.$implicit.username,'');
    if (import3.checkBinding(throwOnChange,this._expr_209,currVal_209)) {
      this.renderer.setElementAttribute(this._el_8,'ticket-name',((currVal_209 == null)? (null as any): currVal_209.toString()));
      this._expr_209 = currVal_209;
    }
    const currVal_210:any = import3.inlineInterpolate(1,'',this.context.$implicit.oid,'');
    if (import3.checkBinding(throwOnChange,this._expr_210,currVal_210)) {
      this.renderer.setElementAttribute(this._el_8,'ticket-id',((currVal_210 == null)? (null as any): currVal_210.toString()));
      this._expr_210 = currVal_210;
    }
    valUnwrapper.reset();
    const currVal_211:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.BOOKING')),' ',valUnwrapper.unwrap(this._pipe_translate_1.transform(this.context.$implicit.status_parsed.toLowerCase())),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_211,currVal_211))) {
      this.renderer.setElementAttribute(this._el_8,'ticket-status',((currVal_211 == null)? (null as any): currVal_211.toString()));
      this._expr_211 = currVal_211;
    }
    const currVal_214:any = import3.inlineInterpolate(1,'',this.context.$implicit.colorBooking,'');
    if (import3.checkBinding(throwOnChange,this._expr_214,currVal_214)) {
      this.renderer.setElementAttribute(this._el_8,'color',((currVal_214 == null)? (null as any): currVal_214.toString()));
      this._expr_214 = currVal_214;
    }
    const currVal_215:any = import3.inlineInterpolate(1,'',((this.context.$implicit.colorBooking == 'black')? '': (((this.context.$implicit.colorBooking == 'green') || (this.context.$implicit.colorBooking == 'red'))? 2: 4)),'');
    if (import3.checkBinding(throwOnChange,this._expr_215,currVal_215)) {
      this.renderer.setElementAttribute(this._el_8,'color-variation',((currVal_215 == null)? (null as any): currVal_215.toString()));
      this._expr_215 = currVal_215;
    }
    const currVal_216:any = import3.inlineInterpolate(1,'',this.parentView.context.getCurrentLang(),'');
    if (import3.checkBinding(throwOnChange,this._expr_216,currVal_216)) {
      this.renderer.setElementAttribute(this._el_8,'locale',((currVal_216 == null)? (null as any): currVal_216.toString()));
      this._expr_216 = currVal_216;
    }
    const currVal_218:any = import3.inlineInterpolate(1,'',this.context.$implicit.carName,'');
    if (import3.checkBinding(throwOnChange,this._expr_218,currVal_218)) {
      this.renderer.setText(this._text_27,currVal_218);
      this._expr_218 = currVal_218;
    }
    const currVal_219:any = import3.inlineInterpolate(1,'',this.context.$implicit.carBrand,' - ');
    if (import3.checkBinding(throwOnChange,this._expr_219,currVal_219)) {
      this.renderer.setText(this._text_32,currVal_219);
      this._expr_219 = currVal_219;
    }
    const currVal_220:any = import3.inlineInterpolate(1,'',this.context.$implicit.carModel,'');
    if (import3.checkBinding(throwOnChange,this._expr_220,currVal_220)) {
      this.renderer.setText(this._text_35,currVal_220);
      this._expr_220 = currVal_220;
    }
    valUnwrapper.reset();
    const currVal_221:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform(this.context.$implicit.pickupDate_parsed.date)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_221,currVal_221))) {
      this.renderer.setText(this._text_59,currVal_221);
      this._expr_221 = currVal_221;
    }
    valUnwrapper.reset();
    const currVal_223:any = import3.inlineInterpolate(2,'',this.context.$implicit.pickupDate_parsed.hour,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('bookingList.CARD.hours')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_223,currVal_223))) {
      this.renderer.setText(this._text_62,currVal_223);
      this._expr_223 = currVal_223;
    }
    const currVal_225:any = import3.inlineInterpolate(1,'',this.context.$implicit.pickupCity,'');
    if (import3.checkBinding(throwOnChange,this._expr_225,currVal_225)) {
      this.renderer.setText(this._text_75,currVal_225);
      this._expr_225 = currVal_225;
    }
    valUnwrapper.reset();
    const currVal_226:any = import3.inlineInterpolate(3,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('bookingList.CARD.duration')),' ',this.context.$implicit.totalDays,' ',((this.context.$implicit.totalDays == 1)? valUnwrapper.unwrap(this._pipe_translate_6.transform('bookingList.CARD.totalDay')): valUnwrapper.unwrap(this._pipe_translate_7.transform('bookingList.CARD.totalDays'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_226,currVal_226))) {
      this.renderer.setText(this._text_87,currVal_226);
      this._expr_226 = currVal_226;
    }
    valUnwrapper.reset();
    const currVal_230:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform(this.context.$implicit.dropoffDate_parsed.date)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_230,currVal_230))) {
      this.renderer.setText(this._text_106,currVal_230);
      this._expr_230 = currVal_230;
    }
    valUnwrapper.reset();
    const currVal_232:any = import3.inlineInterpolate(2,'',this.context.$implicit.dropoffDate_parsed.hour,'',valUnwrapper.unwrap(this._pipe_translate_9.transform('bookingList.CARD.hours')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_232,currVal_232))) {
      this.renderer.setText(this._text_109,currVal_232);
      this._expr_232 = currVal_232;
    }
    const currVal_234:any = import3.inlineInterpolate(1,'',this.context.$implicit.dropoffCity,'');
    if (import3.checkBinding(throwOnChange,this._expr_234,currVal_234)) {
      this.renderer.setText(this._text_122,currVal_234);
      this._expr_234 = currVal_234;
    }
    valUnwrapper.reset();
    const currVal_235:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_10.transform(this.context.$implicit.paymentMethod_parsed)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_235,currVal_235))) {
      this.renderer.setText(this._text_151,currVal_235);
      this._expr_235 = currVal_235;
    }
    valUnwrapper.reset();
    const currVal_237:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_11.transform(this.context.$implicit.paymentDescription)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_237,currVal_237))) {
      this.renderer.setText(this._text_154,currVal_237);
      this._expr_237 = currVal_237;
    }
    valUnwrapper.reset();
    const currVal_239:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_12.transform(this.context.$implicit.paymentTypeDescription)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_239,currVal_239))) {
      this.renderer.setText(this._text_165,currVal_239);
      this._expr_239 = currVal_239;
    }
    const currVal_241:any = import3.inlineInterpolate(1,'',this.context.$implicit.totalToBeCollectedBySupplier_parsed,'');
    if (import3.checkBinding(throwOnChange,this._expr_241,currVal_241)) {
      this.renderer.setText(this._text_170,currVal_241);
      this._expr_241 = currVal_241;
    }
    const currVal_242:any = import3.inlineInterpolate(1,'',this.context.$implicit.currencyCode,'');
    if (import3.checkBinding(throwOnChange,this._expr_242,currVal_242)) {
      this.renderer.setText(this._text_173,currVal_242);
      this._expr_242 = currVal_242;
    }
    this.compView_10.internalDetectChanges(throwOnChange);
    this.compView_142.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._CheckboxContainerComponent_10_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._vc_128.destroyNestedViews();
    this._vc_130.destroyNestedViews();
    this._vc_140.destroyNestedViews();
    this._vc_176.destroyNestedViews();
    this._vc_178.destroyNestedViews();
    this.compView_10.destroy();
    this.compView_142.destroy();
    this._CheckboxContainerComponent_10_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 128)) { return new View_BookingListComponent2(this.viewUtils,this,128,this._anchor_128,this._vc_128); }
    if ((nodeIndex == 130)) { return new View_BookingListComponent3(this.viewUtils,this,130,this._anchor_130,this._vc_130); }
    if ((nodeIndex == 140)) { return new View_BookingListComponent5(this.viewUtils,this,140,this._anchor_140,this._vc_140); }
    if ((nodeIndex == 176)) { return new View_BookingListComponent6(this.viewUtils,this,176,this._anchor_176,this._vc_176); }
    if ((nodeIndex == 178)) { return new View_BookingListComponent7(this.viewUtils,this,178,this._anchor_178,this._vc_178); }
    return (null as any);
  }
  handleEvent_6(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      this.parentView.context.bookingActions($event,this.context.$implicit.oid,this.context.$implicit.companyOid);
      const pd_sub_0:any = ((<any>$event.stopPropagation()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_10(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.$implicit.readMark = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'click')) {
      this.parentView.context.clickReadMark(this.context.$implicit.oid,this.context.$implicit.readMark);
      const pd_sub_1:any = ((<any>$event.stopPropagation()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
var renderType_BookingListComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_BookingListComponent,{});
export class View_BookingListComponent0 extends import2.AppView<import0.BookingListComponent> {
  _anchor_0:any;
  /*private*/ _vc_0:import21.ViewContainer;
  _TemplateRef_0_5:any;
  _NgFor_0_6:import22.Wrapper_NgFor;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_BookingListComponent0,renderType_BookingListComponent,import9.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._anchor_0 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._vc_0 = new import21.ViewContainer(0,(null as any),this,this._anchor_0);
    this._TemplateRef_0_5 = new import23.TemplateRef_(this,0,this._anchor_0);
    this._NgFor_0_6 = new import22.Wrapper_NgFor(this._vc_0.vcRef,this._TemplateRef_0_5,this.parentView.injectorGet(import24.IterableDiffers,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [this._anchor_0]),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (0 === requestNodeIndex))) { return this._TemplateRef_0_5; }
    if (((token === import25.NgFor) && (0 === requestNodeIndex))) { return this._NgFor_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.list;
    this._NgFor_0_6.check_ngForOf(currVal_0_0_0,throwOnChange,false);
    this._NgFor_0_6.ngDoCheck(this,this._anchor_0,throwOnChange);
    this._vc_0.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_0.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 0)) { return new View_BookingListComponent1(this.viewUtils,this,0,this._anchor_0,this._vc_0); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/booking/list/booking-list.component.ngfactory.ts